/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface InvestmentCompanyStatistics {
  /**
   * Auto Added Creation date
   */
  readonly created_date: string;
  readonly total_conversion_rate: string;
  readonly companies_contributions_per_value: string;
  readonly companies_contributions_per_instance: string;
}
